import React from 'react';
import { Col, Form } from 'antd';
import { I18n } from '@aws-amplify/core';

import { useListCompanies } from '@/hooks/v1/useListCompanies';
import { toOptions } from '@/views/Bera/_components/Filter/utils';
import { useApplicationContext } from '@/context/v1/Application/context';
import { HierarchySelect } from '@/views/Bera/_components/Filter/Fields/HierarchySelect';

import type { BeraFilterFormFields } from '@/views/Bera/types';

const { useFormInstance } = Form;

export function Company(): JSX.Element {
	const form = useFormInstance<BeraFilterFormFields>();
	const { organization, company } = useApplicationContext();

	const {
		data: companies,
		isLoading,
		isFetching,
		isError
	} = useListCompanies({
		organization_id: organization?.id,
		company_id: company?.id
	});

	function handleChange(): void {
		const clearedFields = {
			sector_id: undefined,
			line_id: undefined,
			workstation_id: undefined,
			cycle_id: undefined
		};

		form.setFieldsValue(clearedFields);
	}

	return (
		<Col xs={24}>
			<Form.Item name="company_id_filter" label={I18n.get('Industrial site')} labelCol={{ span: 24 }}>
				<HierarchySelect
					onChange={handleChange}
					loading={isFetching}
					options={toOptions(companies)}
					placeholder={I18n.get('Industrial site')}
					disabled={isLoading || isFetching || isError}
				/>
			</Form.Item>
		</Col>
	);
}
